import { FeeItemInstance } from '@app/features/scope-overview/model/fee-item.model'

export function getFeeChanges(
  scopeFeeItems: FeeItemInstance[] = [],
  previewFeeItems: FeeItemInstance[] = []
): FeeItemInstance[] {
  if (!scopeFeeItems) scopeFeeItems = []
  if (!previewFeeItems) previewFeeItems = []

  const feeItemIds = new Set(scopeFeeItems.map((f) => f.id))
  const allFeeItems = [...scopeFeeItems, ...previewFeeItems.filter((p) => !feeItemIds.has(p.id))]

  return allFeeItems.map((feeItem) => {
    return {
      ...feeItem,
      isAdded: !feeItemIds.has(feeItem.id),
      isRemoved: feeItemIds.has(feeItem.id) && !previewFeeItems.find((p) => p.id === feeItem.id),
    }
  })
}
